import { axios } from './axios';

export const getProducts = async (country: string) => {
  return axios.get(`/products/codes?country=${country}`);
};
